module.exports = __webpack_public_path__ + "media/images/front/icon_pr-d1655a14bf9bc35660b88496732d4182.png";